/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

window.initilizeRechargeWidget = (productId = null, placement) => {
  let widgetPlacement = (typeof placement == "string") ? document.querySelector(placement) : placement;
  if (widgetPlacement != null && productId != null) {
    let rechargeObject = setInterval(() => {
      if (window.ReChargeWidget) {        
        window.ReChargeWidget.createWidget({ productId: productId, injectionParent: widgetPlacement });                
        clearInterval(rechargeObject);
        customQuickViewPrice()
      }
    }, 5000);

    window.addEventListener('load', () => {
      setTimeout(() => {
        customCollectionPrice();
        clearInterval(rechargeObject);
      }, 5000);
    });
  }
};
// console.log("window.initilizeRechargeWidge",window.initilizeRechargeWidge);
//Custom Collection Price
function customCollectionPrice() {
  document.querySelectorAll('[data-product-grid-item]').forEach(function(Ele){    
    if(Ele.querySelector('.custom-widget') && Ele.querySelector('.custom-widget').querySelector('[data-option-onetime] [data-price-onetime]') && Ele.querySelector('.custom-widget').querySelector('[data-option-subsave] [data-label-discount]').innerHTML != ''){
          let originalPrice = Ele.querySelector('.custom-widget').querySelector('[data-option-onetime] [data-price-onetime]').innerHTML,
          finalOriginalPrice = originalPrice.replace("$", ""),
          discountPercentage = parseInt(Ele.querySelector('.custom-widget').querySelector('[data-option-subsave] [data-label-discount]').innerHTML),
          discountAmount = (finalOriginalPrice * discountPercentage) / 100,
          discountedPrice = finalOriginalPrice - discountAmount
      console.log("discountedPrice",discountedPrice,"originalPrice",originalPrice);
      Ele.querySelector('.custom-widget').querySelector('[data-option-subsave] [data-price-subsave]').innerHTML = `$${discountedPrice.toFixed(2)}`;
      Ele.querySelector('.custom-widget').querySelector('[data-option-onetime] [data-price-onetime]').innerHTML = Ele.querySelector('product-form [data-product-price] .custom_price').innerHTML;    
    }
    })
}

function customQuickViewPrice() {
document.querySelectorAll('[data-product-grid-item]').forEach(function(Ele){    
  if(Ele.querySelector('.modal').querySelector('.shopify-section')){     
    setTimeout(function(){
     if(Ele.querySelector('.custom-widget').querySelector('[data-option-subsave] [data-label-discount]').innerHTML != ''){       
      let originalPrice = Ele.querySelector('.modal').querySelector('[data-form-wrapper] [data-product-price]').innerHTML,
        finalOriginalPrice = originalPrice.replace("$", ""),
        discountPercentage = parseInt(Ele.querySelector('.modal').querySelector('[data-option-subsave] [data-label-discount]').innerHTML),
        discountAmount = (finalOriginalPrice * discountPercentage) / 100,
        discountedPrice = finalOriginalPrice - discountAmount
  
      Ele.querySelector('.modal').querySelector('[data-option-subsave] [data-price-subsave]').innerHTML = `$${discountedPrice.toFixed(2)}`;
      Ele.querySelector('.modal').querySelector('[data-widget-container]').querySelector('[data-option-onetime] [data-price-onetime]').innerHTML = Ele.querySelector('.modal').querySelector('[data-form-wrapper] [data-product-price]').innerHTML;      
     }else{
      Ele.querySelector('.modal').querySelector('[data-option-subsave] [data-price-subsave]').innerHTML = '';
      Ele.querySelector('.modal').querySelector('[data-widget-container]').querySelector('[data-option-onetime] [data-price-onetime]').innerHTML = '';      
     } 
    },500);    
   }
  })
}

// upsellslider start
function enhanceUpsellSlider() {
  const upsellContainer = document.querySelector('.cart__widget__products[data-upsell-products]');
  if (!upsellContainer) return;
  upsellContainer.classList.add('swiper');
  let wrapper = upsellContainer.querySelector('.swiper-wrapper');
  if (!wrapper) {
    const newWrapper = document.createElement('div');
    newWrapper.classList.add('swiper-wrapper');
    [...upsellContainer.children].forEach(child => newWrapper.appendChild(child));
    upsellContainer.appendChild(newWrapper);
    wrapper = newWrapper;
  }
  wrapper.querySelectorAll(':scope > *').forEach(child => child.classList.add('swiper-slide'));

  if (!upsellContainer.querySelector('.swiper-button-prev')) {
    upsellContainer.insertAdjacentHTML('beforeend', `
      <div class="swiper-pagination"></div>
    `);
  }
}
function initUpsellSwiper() {
  const cartPageWrapper = document.querySelector('.cart-page-wrapper');
  if (typeof Swiper === 'undefined') return;

  const slidesForDesktop = cartPageWrapper ? 4 : 2.19;
  const slidesForIpad = cartPageWrapper ? 3 : 2.19;
  const slidesForMobile = cartPageWrapper ? 2 : 2.19;

  new Swiper('.cart__widget__products.swiper', {
    slidesPerView: slidesForMobile,
    spaceBetween: 8,
    loop: false,
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    },
    breakpoints: {
      768: {
        slidesPerView: slidesForIpad
      },
      1024: {
        slidesPerView: slidesForDesktop
      }
    }
  });
}

function setupUpsellSwiperOnceLoaded() {
  enhanceUpsellSlider();
  initUpsellSwiper();
}
// Works for full page load
document.addEventListener('DOMContentLoaded', setupUpsellSwiperOnceLoaded);
// upsellslider end
// custom nav filter featured_collection_nav_item
 document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.featured_collection_nav_item').forEach(function (link) {
      link.addEventListener('click', function (e) {
        const targetId = this.getAttribute('href');
        const targetEl = document.querySelector(targetId);

        if (targetEl) {
          e.preventDefault();

          // Determine offset based on screen width
          const screenWidth = window.innerWidth;
          let headerOffset;

          if (screenWidth <= 767) {
            headerOffset = 230; // mobile
          } else if (screenWidth <= 1024) {
            headerOffset = 160; // tablet
          } else {
            headerOffset = 100; // desktop
          }

          const elementPosition = targetEl.getBoundingClientRect().top + window.pageYOffset;
          const offsetPosition = elementPosition - headerOffset;

          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
      });
    });
  });
// end custom nav filter featured_collection_nav_item

// tamplate all filter

class CustomCollectionFiltersForm extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener('click', (event) => {
      const input = event.target;
      if (input.tagName === 'INPUT' && input.type === 'checkbox') {
        input.closest('li')?.classList.toggle('active');
        this.handleFilterChange(input);
      }
    });
      const viewItemsBtn = this.querySelector('.view_items_with_count');
      if (viewItemsBtn) {
        viewItemsBtn.addEventListener('click', (e) => {
          e.preventDefault();

          const productGridsMobile = document.querySelector('[data-products-grid]');
          if (productGridsMobile) {
            productGridsMobile.classList.add('is-loading'); 

            setTimeout(() => {
              productGridsMobile.classList.remove('is-loading');
            }, 600);
            window.scrollTo({ top: 0, behavior: 'smooth' });
          }
        });
      }
  }

  handleFilterChange(input) {
    this.filterProducts();
    this.updateActiveFilterTags(input);
  }

  filterProducts() {
      const productGrids = document.querySelector('[data-products-grid]');
      if (productGrids) productGrids.classList.add('is-loading'); 
  
    const activeFilters = Array.from(this.querySelectorAll('input[type="checkbox"]:checked')).map(input => ({
      key: this.extractKey(input.name),
      value: input.value.trim().toLowerCase()
    }));

    const productGrid = document.querySelector('[data-products-grid]');
    const productItems = productGrid?.querySelectorAll('[data-product-grid-item]') || [];

    productItems.forEach((product) => {
      const matches = activeFilters.some(filter => {
        const dataAttr = `data-product_${filter.key.toLowerCase()}`;
        const rawValue = (product.getAttribute(dataAttr) || '').toLowerCase();
        return rawValue.split(',').map(v => v.trim()).includes(filter.value);
      });

      const show = activeFilters.length === 0 || matches;
      product.classList.toggle('hidden', !show);
    });

    this.updateVisibleCounts();
        setTimeout(() => {
        if (productGrid) productGrid.classList.remove('is-loading');
      }, 600); 
      window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  updateActiveFilterTags(input) {
    const wrapper = this.querySelector('.collection__active__filters');
    const tagSelector = `[data-value="${input.value}"]`;

    if (input.checked) {
      if (!wrapper.querySelector(tagSelector)) {
        const tag = document.createElement('a');
        tag.className = 'active__filters__remove';
        tag.href = '#';
        tag.setAttribute('data-filter-update-url', '');
        tag.setAttribute('data-value', input.value);
        tag.innerHTML = `
          <small>${input.value}</small>
          <span class="filter__x">
            <svg aria-hidden="true" focusable="false" role="presentation" width="24" height="24" class="icon icon-cancel" viewBox="0 0 24 24">
              <path d="M6.758 17.243 12.001 12m5.243-5.243L12 12m0 0L6.758 6.757M12.001 12l5.243 5.243"
                stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path>
            </svg>
          </span>
        `;

        tag.addEventListener('click', (e) => {
          e.preventDefault();
          input.checked = false;
          tag.remove();
          this.filterProducts();
          this.updateClearAllButton();
        });

        wrapper.appendChild(tag);
      }
    } else {
      wrapper.querySelector(tagSelector)?.remove();
    }

    this.updateClearAllButton();
  }

  updateClearAllButton() {
    const wrapper = this.querySelector('.collection__active__filters');
    const tags = wrapper.querySelectorAll('.active__filters__remove');
    let clearBtn = wrapper.querySelector('.active__filters__clear');

    if (tags.length < 2 && clearBtn) {
      clearBtn.remove();
    }

    if (tags.length >= 2 && !clearBtn) {
      clearBtn = document.createElement('a');
      clearBtn.className = 'active__filters__clear';
      clearBtn.href = '/collections/all?view=all';
      clearBtn.setAttribute('data-filter-update-url', '');
      clearBtn.innerHTML = `<small>Clear Filters</small>`;

      clearBtn.addEventListener('click', (e) => {
        e.preventDefault();
        this.clearAllFilters();
      });

      wrapper.insertBefore(clearBtn, wrapper.firstChild);
    }
  }

  updateVisibleCounts() {
    const allProducts = document.querySelectorAll('[data-product-grid-item]');
    const visibleProducts = document.querySelectorAll('[data-product-grid-item]:not(.hidden)');
    const countMap = {};

    allProducts.forEach(product => {
      const handle = product.getAttribute('data-collection_handle');
      if (handle && !(handle in countMap)) countMap[handle] = 0;
    });

    visibleProducts.forEach(product => {
      const handle = product.getAttribute('data-collection_handle');
      if (handle) countMap[handle]++;
    });

    Object.entries(countMap).forEach(([handle, count]) => {
      const section = document.getElementById(handle);
      if (!section) return;

      const countEl = section.querySelector('.product_count');
      if (countEl) {
        countEl.textContent = `${count} product${count !== 1 ? 's' : ''}`;
      }

      const next = section.nextElementSibling;
      if (next?.classList.contains('not-found-product')) {
        next.remove();
      }

      if (count === 0) {
        const notFound = document.createElement('div');
        notFound.className = 'not-found-product';
        notFound.textContent = 'Not Found';
        section.insertAdjacentElement('afterend', notFound);
      }
    });

    const totalEl = document.querySelector('.view_items_with_count');
    if (totalEl) {
      totalEl.textContent = `View All ${visibleProducts.length} Product${visibleProducts.length !== 1 ? 's' : ''}`;
    }
  }

  clearAllFilters() {
    const wrapper = this.querySelector('.collection__active__filters');
    this.querySelectorAll('input[type="checkbox"]').forEach(cb => cb.checked = false);
    wrapper.querySelectorAll('.active__filters__remove').forEach(tag => tag.remove());
    wrapper.querySelector('.active__filters__clear')?.remove();

    this.filterProducts();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  extractKey(nameAttr) {
    return nameAttr.split('.').pop();
  }
}

customElements.define('custom-collection-filters-form', CustomCollectionFiltersForm);

// end template all filter

// Dropdown toggle functionality

document.addEventListener('DOMContentLoaded', function () {
  const toggles = document.querySelectorAll('.dropdown-toggle');

  toggles.forEach(toggle => {
    toggle.addEventListener('click', function (e) {
      const parentItem = this.closest('.has-children');
      parentItem.classList.toggle('open');
    });
  });
});

const sliderBlog = document.querySelector('.js-blog-slider');
if (sliderBlog) {
  const slidesDesktop = parseFloat(sliderBlog.dataset.slidesDesktop) || 4;

  new Swiper(sliderBlog, {
    slidesPerView: 1.152,
    spaceBetween: 32,
    loop: false,
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    },
    breakpoints: {
      768: {
        slidesPerView: 3
      },
      1024: {
        slidesPerView: slidesDesktop
      }
    }
  });
}
